import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'
import { AudienceWidget } from '@/widgets/analytics'

export const AudiencePage = () => {
    const { activeWorkspace } = useActiveWorkspace()

    if (activeWorkspace.workspace_type === 'site') {
        return null
    }
    return <AudienceWidget activeChannel={activeWorkspace} />
}
